import React, { useEffect } from "react";
import perfil from '../asset/img/profile.jpg'
const About = () => {


  const cvIngles = () => {
    window.open('./CV/Rafael Martinez CVl.pdf')
  }
  const cvEspa = () => {
    window.open('./CV/Rafael Martinez CVl ESPANOL.pdf')
  }

  const calcularEdad = () => {
    let hoy = new Date();
    const cumpleanos = new Date(2000, 2, 18);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    let m = hoy.getMonth() - cumpleanos.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }
    return edad;
  }

  return (
    <div className="container py-5 mb-5" id="about">
      <div className="row">
        <div className="col-lg-6 col-xm-12">
          <div className="photo-wrap">
            <img
              className="img-fluid sm-display-none profile-img-about"
              src={perfil}
              alt="Perfil"></img>
          </div>
        </div>
        <div className="col-lg-6 col-xm-12 heading-section ftco-animate">
          <h2 className="mb-4 mb-md-4 sobremi font-weight-bold colorTexto">Sobre mí</h2>
          <p>Soy un joven apasionado por el desarrollo de software.</p>
          <ul className="about-info mt-4 px-md-0 px-2">
            <li className="d-flex">
              <span className="span">Nombre:</span>{" "}
              <span className="">RAFAEL MARTINEZ</span>
            </li>
            <li className="d-flex">
              <span className="span">Edad:</span>
              <span className="" >{calcularEdad()} años</span>
            </li>
            <li className="d-flex">
              <span className="span">Direccion:</span>{" "}
              <span className="">Quezaltepeque, La Libertad</span>
            </li>
            <li className="d-flex">
              <span className="span">Email:</span>{"    "}
              <span> <a href="mailto:rafaelvady.q@gmail.com">rafaelvady.q @gmail.com </a> </span>
            </li>
            <li className="d-flex">
              <span className="span">telefono: </span>{" "}
              <span><a href="tel:+50375511863">+503 7551-1863</a></span>
            </li>
          </ul>
          <div className="counter-wrap ftco-animate d-flex mt-md-3">
            <div className="text">


              <div class="btn-group mt-6">
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Descargar CV
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" style={{cursor:'pointer'}} onClick={cvEspa}>Español</a>
                  {/* <a class="dropdown-item" style={{cursor:'pointer'}} onClick={cvIngles}>Inglés</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;

